import React from "react";
import { Link } from "react-router-dom";

//Link to a page on the site ("path"), or to another site / a PDF ("href", opens in a new tab)
const SmartLink = ({ path, href, children, ...rest }) => {
  if (path) {
    return (
      <Link
        to={path}
        {...rest}
      >
        {children}
      </Link>
    );
  }
  const isMail = href.startsWith("mailto:") || href.startsWith("tel:");
  return (
    <a
      href={href}
      target={isMail ? undefined : "_blank"}
      rel={isMail ? undefined : "noopener noreferrer"}
      {...rest}
    >
      {children}
    </a>
  );
};

export default SmartLink;
